import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LocumsUtility } from 'src/app/locums/locums-utility';
import { BoardCertification } from 'src/app/locums/models/board-certification.model';
import { LocumsJobService } from 'src/app/locums/services/locums-job.service';

@UntilDestroy()
@Component({
    selector: 'nova-locums-recruiter-board-certs',
    templateUrl: './locums-recruiter-board-certs.component.html',
    styleUrls: ['./locums-recruiter-board-certs.component.scss']
})
export class LocumsRecruiterBoardCertificationsComponent implements OnInit {
    @Input() jobId: number;
    boardCertifications: BoardCertification[];
    locumsUtility = LocumsUtility;

    constructor(private readonly locumsJobService: LocumsJobService) {}

    ngOnInit(): void {
        this.locumsJobService
            .getBoardCertifications(this.jobId)
            .pipe(untilDestroyed(this))
            .subscribe((certifications: BoardCertification[]) => {
                this.boardCertifications = certifications;
            });
    }
}
